import React from "react";

import { GridViewProps } from "./GridView.props";
import "./GridView.styles.scss";

export const GridView = ({ children }: GridViewProps) => {
  return <div className="grid-view">{children}</div>;
};
